import React, {useEffect} from 'react';
import HomeGrid from '../Components/HomeGrid/HomeGrid';
import MainBanner from '../Components/MainBanner/MainBanner';
import ImagePopup from '../Components/ImagePopup/ImagePopup';

const HomePage=(props)=>{

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

	return(
		<React.Fragment>
			<MainBanner 
				background_left="/preseedherbicide/images/DIGFARM_CANOLA_BWM_3804_2019@2x.png"
				background_left_alt=""
				background_right=""
				background_right_alt=""
			/>
			<HomeGrid/>
		</React.Fragment>
	);
}

export default HomePage;

